<script setup lang="ts">
import { computed, defineProps } from 'vue'
const AdventureTypeListItem = () => import('@/components/molecules/adventure/AdventureTypeListItem.vue')

const props = defineProps<{
  adventureTypes: Array<any>
  landType: number
  departurable: boolean
}>()

const sortedAdventureTypes = computed(() => {
  const adventureTypes = []

  for (const adventureType of props.adventureTypes) {
    if (!adventureType.landTypesList.length) {
      adventureTypes.push(adventureType)
      continue
    }

    if (adventureType.landTypesList.includes(props.landType)) {
      adventureTypes.push(adventureType)
    }
  }

  return adventureTypes
})
</script>

<template>
  <div class="grid gap-4 md:gap-8 md:grid-cols-2">
    <template v-for="adventureType in sortedAdventureTypes">
      <AdventureTypeListItem
        :adventure-type="adventureType"
        :departurable="departurable"
        @departure="adventureType => $emit('departure', adventureType)"
        @click-info="adventureType => $emit('click-info', adventureType)"
      />
    </template>
  </div>
</template>
